import styled from "styled-components";

export const InputContainer = styled.div`
  width: 100%;
  &.responsive {
    .react-select__control {
      min-height: clamp(33px, 2.292vw, 44px);
    }
    .react-select__single-value {
      font-size: clamp(10px, 0.729vw, 14px);
    }
    .react-select__indicator {
      padding: clamp(6px, 0.417vw, 8px);
      svg {
        height: clamp(16px, 1.042vw, 20px);
        width: clamp(16px, 1.042vw, 20px);
      }
    }
    .react-select__option {
      font-size: clamp(10px, 0.729vw, 14px);
    }
    .input-container label {
      transform: translate(0, clamp(10px, 0.625vw, 12px)) scale(1);
      font-size: clamp(10px, 0.729vw, 14px);
      /* line-height: 122%; */
      /* left: 16px; */
    }
    .input-container .filled,
    .input-container:focus-within label {
      font-size: clamp(10px, 0.729vw, 14px);
      transform: translate(0, -14px) scale(1);
    }
    .input-container > input {
      padding: clamp(10px, 0.625vw, 12px) 16px clamp(10px, 0.625vw, 12px) 0;
      font-size: clamp(10px, 0.729vw, 14px);
    }
    .app-input-text input {
      font-size: clamp(10px, 0.729vw, 14px);
    }
  }
  .input-container {
    position: relative;
    display: flex;
    flex-direction: column;
    input::-webkit-input-placeholder {
      color: #9c9c9c !important;
      font-size: 14px !important;
    }
  }

  .input-container:focus-within label {
    transform: translate(0, -14px) scale(0.8);
    /* color: #0a53e4; */
    font-size: 14px;
    /* line-height: 14px; */
    letter-spacing: 0.005em;
    color: #70707080;
  }

  .input-container .filled {
    transform: translate(0, -14px) scale(0.8);
    /* font-size: 18px; */
    line-height: 14px;
    letter-spacing: 0.005em;
    color: #70707080;
  }
  .react-select__control {
    min-height: 44px;
    border: none;
    border-bottom: 1px solid #e0e0e0;
    border-radius: 0;
    box-shadow: none;
    :hover {
      border-color: #e0e0e0;
    }
  }
  /* .react-select__value-container {
    padding-left: 0;
    padding-right: 0;
  } */
  .input-container label {
    position: absolute;
    pointer-events: none;
    transform: translate(0, 12px) scale(1);
    transform-origin: top left;
    transition: 200ms cubic-bezier(0, 0, 0.2, 1) 0ms;
    color: #70707080;
    font-size: 14px;
    /* line-height: 122%; */
    /* left: 16px; */
  }

  .input-container > input {
    /* height: 64px; */
    font-family: "latomedium" !important;
    border-radius: 4px;
    border: none;
    padding: 12px 16px 12px 0;
    font-size: 14px;
    line-height: 1;
    outline: none;
    box-shadow: none;
    border-bottom: 1px solid #e0e0e0;
    border-radius: 0;
    transition: 200ms cubic-bezier(0, 0, 0.2, 1) 0ms;
  }

  /* .input-container input:focus {
    box-shadow: 0 0 0 2px #79b1ff;
  } */
`;
